import { useState, useEffect } from "react";

export const displayTooltip = (width=2100) => {
  const [disableTooltip, setDisableTooltip] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setDisableTooltip(screenWidth >= width);
    };

    handleResize(); // Check initial width
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [disableTooltip]);
  return disableTooltip;
};
